import { Component, OnInit } from '@angular/core';
import {CommonService} from '../services/common.service';

@Component({
  selector: 'app-capitals',
  templateUrl: './capitals.component.html',
  styleUrls: ['./capitals.component.css']
})
export class CapitalsComponent implements OnInit {

   path;

   constructor(private common: CommonService) {
   }

   ngOnInit(): void {
      this.path = this.common;
      window.scrollTo(0, 0);
   }

}
